// User identity types
export type UserRole = "reviewer" | "reviewee";

export interface UserIdentity {
  roles: UserRole[];
  isReviewer: boolean;
  isReviewee: boolean;
}

// Default identity - all new users start as reviewees
export const DEFAULT_IDENTITY: UserIdentity = {
  roles: ["reviewee"],
  isReviewer: false,
  isReviewee: true,
};
